// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ('../node_modules/vuetify/dist/vuetify.min.css')
import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App'
import router from './js/router'
import {
  store
} from './js/store/store'
import Headerapp from './components/ui/Header'
import Menunav from './components/ui/Menunav.vue'
import TitleRed from './components/ui/Titlered'
import TitleCen from './components/ui/Titlecen'
import TitleOne from './components/ui/Titleone'
import TitleTwo from './components/ui/Titletwo'
import CircleSpan from './components/ui/CircleSpan.vue'
import Imageimport from './components/ui/Imageimport'
import Footerapp from './components/ui/Footer'
import Accesmenu from './components/ui/Accesmenu'
import Accesvideo from './components/ui/Accesvideo'
import Hovergif from './components/ui/HoverGif'
import NavButtons from './components/ui/Navbuttons'
import NavAtras from './components/ui/NavAtras'
import NavAdel from './components/ui/NavAdel'
import Button from './components/ui/Button'
import BotSlide from './components/ui/BotSlide.vue'
import TabsButtonsSlide from './components/ui/tabsButtonsSlide.vue'
import TabsButtonsSlideList from './components/ui/tabsButtonsSlideList.vue'
import ButtonExpandCont from './components/ui/ButtonExpandCont.vue'
import BotAcronimo from './components/ui/BotsAcronimo.vue'
import TopNav from './components/ui/TopNavigation.vue'
import Buttoncirclesecondary from './components/ui/Buttoncirclesecondary.vue'
import Buttoncircleprimary from './components/ui/Buttoncircleprimary.vue'
import Diagfull from './components/ui/Diagfull'
import Accordion from './components/ui/accordion'
import Globodiag from './components/ui/Globodiag'
import Glosario from './components/ui/Glosario'
import Creditos from './components/ui/Creditos'
import Videos from './components/ui/Videos'
import VideoApp from './components/ui/Videoimport'
import Bibliografia from './components/ui/Bibliografia'
import SimpleLsc from './components/ui/ui-simple-lsc.vue'
import LscDialog from './components/ui/ui-lsc-dialog.vue'
import NombreTema from './components/ui/Nombretema.vue'
import ActividadDragBack from './components/actividades/Actividad-drag-back.vue'
import TextoMarco from './components/ui/Textomarco'
import ActPreguntas01 from './components/actividades/act-preguntas-01'
import ActPantallaFinal from './components/actividades/act-pantallafinal'
import AppList from './components/ui/ui-list.vue'
import AppNumList from './components/ui/ui-numlist.vue'
import FinalCurso from './components/ui/FinalCurso.vue'
import CalculadoraPres from './components/ui/FormCalculadora.vue'
import CalculadoraTotal from './components/ui/FormCalculadoraTotal.vue'
import CalculadoraPrint from './components/ui/FormCalculadoraPrint.vue'
import CalculadoraPatrimonio from './components/ui/FormCalculadoraPatrimonio.vue'
import CalculadoraPatrimonioPrint from './components/ui/FormCalculadoraPrintPatrimonio.vue'
import BannerSlide from './components/ui/BannerSlide.vue'
import BotsNumberVert from './components/ui/BotsNumberVert.vue'
import BotsNumberBottom from './components/ui/BotsNumberBottom.vue'
import DiagTooltip from './components/ui/DiagTooltip.vue'
import tooltip from './components/ui/Tooltip.vue'
import AudioPlayer from './components/ui/AudioPlayer.vue';

Vue.config.productionTip = false

// This is the UI componentlibrary
Vue.use(Vuetify)

// Register here all the components
Vue.component('header-app', Headerapp)
Vue.component('menunav-app', Menunav)
Vue.component('image-app', Imageimport)
Vue.component('footer-app', Footerapp)
Vue.component('accesmen-app', Accesmenu)
Vue.component('accesvideo-app', Accesvideo)
Vue.component('hovergif-app', Hovergif)
Vue.component('navbuttons-app', NavButtons)
Vue.component('navatras-app', NavAtras)
Vue.component('navadel-app', NavAdel)
// UI Components
Vue.component('ui-title-red', TitleRed);
Vue.component('ui-title-cen', TitleCen);
Vue.component('ui-title-one', TitleOne);
Vue.component('ui-title-two', TitleTwo);
Vue.component('ui-button', Button);
Vue.component('ui-botslide', BotSlide);
Vue.component('tabs-button-slide', TabsButtonsSlide);
Vue.component('button-slide-list', TabsButtonsSlideList);
Vue.component('button-expand-cont', ButtonExpandCont);
Vue.component('ui-botsacronimos', BotAcronimo);
Vue.component('ui-topnav', TopNav);
Vue.component('ui-button-circle-secondary', Buttoncirclesecondary);
Vue.component('ui-button-circle', Buttoncircleprimary);
Vue.component('ui-circle-span', CircleSpan);
Vue.component("diagfull-app", Diagfull);
Vue.component("accordion-app", Accordion);
Vue.component("globodiag-app", Globodiag);
Vue.component("ui-glosario", Glosario);
Vue.component("ui-creditos", Creditos);
Vue.component("ui-videos", Videos);
Vue.component("video-app", VideoApp);
Vue.component("ui-bibliografia", Bibliografia);
Vue.component("ui-simple-lsc", SimpleLsc);
Vue.component("ui-lsc-dialog", LscDialog);
Vue.component("ui-nombre-tema", NombreTema);
Vue.component("act-drag-back", ActividadDragBack);
Vue.component("ui-textomarco", TextoMarco);
Vue.component("ui-list", AppList);
Vue.component("ui-numlist", AppNumList);
Vue.component("ui-finalcurso", FinalCurso);
Vue.component("ui-calculadora", CalculadoraPres);
Vue.component("ui-calculadora-total", CalculadoraTotal);
Vue.component("ui-calculadora-print", CalculadoraPrint);
Vue.component("ui-calculadora-patri", CalculadoraPatrimonio);
Vue.component("ui-calculadora-print-patri", CalculadoraPatrimonioPrint);
Vue.component("banner-slide-app", BannerSlide);
Vue.component("bots-numbers-vert", BotsNumberVert);
Vue.component("bots-numbers-bottom", BotsNumberBottom);
Vue.component("diag-tooltip", DiagTooltip);
Vue.component('tooltip', tooltip);
Vue.component("audio-player",AudioPlayer);

// Actividades
Vue.component('ui-act-preguntas01', ActPreguntas01);
Vue.component('ui-act-pantallafinal', ActPantallaFinal);

Vue.prototype.$color = 'light';

// Register a global custom directive called `v-focus`
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  },
  componentUpdated: function (el) {
    // Focus the element
    el.focus()
  }
})

/* eslint-disable no-new */
new Vue({
  store: store,
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
});



// WEBPACK FOOTER //
// ./src/main.js